import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WA_INTENTS = [
  { key: "looking_roommate", label: "1. Looking for Roommate" },
  { key: "owner_property", label: "2. Owner Property" },
  { key: "room_available", label: "3. Room Available" },
  { key: "broker_pg", label: "4. Broker / PG Owner" },
];

export const buildWaMessage = (key, l) => {
  const name = l.owner_name || "there";
  const where = [l.locality, l.city].filter(Boolean).join(", ") || "your area";
  const rent = l.rent_inr ? `₹${Number(l.rent_inr).toLocaleString("en-IN")}` : "your budget";
  const ref = l.listing_code || (l.id || "").slice(0, 8);
  const body = {
    looking_roommate: `We have verified roommates looking for a shared stay in ${where} around ${rent}. Shall we share matching profiles with you?`,
    owner_property: `We saw your property in ${where}. HeylpMate can list it FREE and send verified tenants directly — no brokerage. Can we go live today?`,
    room_available: `Your room in ${where} at ${rent} is getting enquiries on HeylpMate. Is it still available? Reply YES to keep it live.`,
    broker_pg: `HeylpMate partners with brokers & PG owners in ${where}. Get verified leads + a free listing dashboard. Interested in a 2-min call?`,
  }[key];
  return `Hi ${name}, this is HeylpMate Flatmate Assist 🏠\n\n${body}\n\nRef: ${ref}\nReply here or visit heylpmate.com/flatmate`;
};

export function FlatmateWaIntents({ listing, token }) {
  const [busy, setBusy] = useState(null);
  const phone = listing.mobile || listing.owner_phone;

  const send = async (key) => {
    if (!phone) return toast.error("No mobile number on this listing");
    setBusy(key);
    try {
      const r = await axios.post(`${API}/admin/whatsapp/send`,
        { to_phone: String(phone), template_key: `flatmate_${key}`, message: buildWaMessage(key, listing) },
        { headers: { Authorization: `Bearer ${token}` } });
      window.open(r.data.wa_url, "_blank");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not prepare WhatsApp message");
    } finally { setBusy(null); }
  };

  return (
    <div className="mb-3 flex flex-wrap items-center gap-2" data-testid={`wa-intents-${listing.id}`}>
      <span className="text-[10px] uppercase tracking-widest font-bold inline-flex items-center gap-1" style={{ color: "#16A34A" }}>
        <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
      </span>
      {WA_INTENTS.map((i) => (
        <button key={i.key} disabled={!!busy} data-testid={`wa-intent-${i.key}-${listing.id}`} onClick={() => send(i.key)}
          title={buildWaMessage(i.key, listing)}
          className="rounded-full border px-3 py-1 text-[11px] font-bold hover:bg-green-50 transition-colors disabled:opacity-50"
          style={{ borderColor: "#16A34A", color: "#16A34A" }}>
          {busy === i.key ? "Opening…" : i.label}
        </button>
      ))}
    </div>
  );
}
